<template>
  <div>
    
    <div class="bar_nav">
      <div class="title">群组成员</div>
      <div class="bar_back_btn" @click="goToGroupHome">群组主页</div>
      <div class="bar_btns_right" v-if="currentUserId === group.ownerId">
        <div class="txtbtn_on_bar_right" @click="goToAddMember">添加</div>
        <div class="txtbtn_on_bar_right" @click="goToRemoveMember">移出</div>
      </div>
    </div>
    <div class="bar_empty"></div>

    <div class="join_area" v-if="currentUserId === group.ownerId">
      <div class="btns">
      <div class="btn qrcode" @click="goToQRCode">群二维码</div>
      <div class="btn invite_link" @click="goToInviteLink">邀请链接</div>
      </div>

        <div class="switch_box">
          <mt-switch class="switch" v-model="enableInviteCode" @change="switchInviteCode"></mt-switch>
          <div class="text">允许加群</div>
        </div>
        <!-- <input class="field" label="邀请码" placeholder="请创建一个邀请码" type="text" v-model="inviteCode" />
        <div class="btn_large_border" @click="updateGroup">保存邀请码</div> -->
    </div>
    
    <div class="box_height_vh100">
      <div class="avatar_collection">
        <div class="avatar_box_width" v-for="member in groupMembers" :key="member.id">
          <div class="avatar_box_padding">
            <div class="avatar_box_ratio">
              <div class="avatar_box_absolute">
                <div class="image_ratio">
                  <div class="image" :style="{'backgroundImage': 'url(' + member.avatarCdnUrl + ')'}" v-if="member.avatar"></div>
                  <div class="image default_avatar" v-if="!member.avatar"></div>
                  <div class="circle_border"></div>
                </div>
                <div class="avatar_name">{{member.fullName}}</div>
              </div>
            </div>
          </div>
        </div>

         <div class="avatar_box_width" v-for="member in groupNoUsers" :key="member.id">
          <div class="avatar_box_padding">
            <div class="avatar_box_ratio">
              <div class="avatar_box_absolute">
                <div class="image_ratio">
                 
                  <div class="image default_avatar"></div>
                  <div class="circle_border"></div>
                </div>
                <div class="avatar_name">{{member.mobilePhone}}</div>
                <div class="no_user">未注册</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    
    </div>

    
    <div class="footer_area">
      <button class="btn_quit_group" @click="quitGroup" v-if="currentUserId !== -1 && currentUserId !== group.ownerId">退出群</button>
    </div>

  </div>
</template>

<script>
export default {
  name: 'GroupSetting',
  data: function () {
    return {
      group: {},
      groupMembers: [],
      groupNoUsers: [],
      currentUserId: -1,
      enableInviteCode: true
    }
  },
  async created() {
    try {
      this.group = await this.$faApi.getGroupDetail(this.$route.params.groupId)
      this.groupMembers = (await this.$faApi.getGroupMembers(this.$route.params.groupId)).data

      this.groupNoUsers = (await this.$faApi.getGroupNoUsers(this.$route.params.groupId)).data
      this.currentUserId = (await this.$faApi.isLogin()).userId
      this.enableInviteCode = this.group.enableInviteCode === 1
    } catch (err) {
      this.$faLogger.error('GroupSetting.vue:created', err)
    }
  },
  methods: {
    async quitGroup() {
      try {
        await this.$faApi.quitGroup(this.$route.params.groupId)
        const currentUserId = (await this.$faApi.isLogin()).userId
        this.$router.push({ path: `/user/${currentUserId}/joined_groups` })
      } catch (err) {
        this.$faLogger.error('GroupSetting.vue:quitGroup', err)
      }
    },
    async switchInviteCode() {
      try {
        await this.$faApi.updateGroup(this.$route.params.groupId, {
          enableInviteCode: +this.enableInviteCode
        })
      } catch (err) {
        this.$faLoggr.error('GroupInviteLink.vue:updateGroup', err)
      }
    },
    async goToGroupHome() {
      this.$router.push({ path: `/group/${this.$route.params.groupId}` })
    },
    goToQRCode() {
      this.$router.push({ path: `/group/${this.$route.params.groupId}/qrcode` })
    },
    goToInviteLink() {
      this.$router.push({ path: `/group/${this.$route.params.groupId}/invite_link` })
    },
    goToAddMember() {
      this.$router.push({ path: `/group/${this.$route.params.groupId}/add_member` })
    },
    goToRemoveMember() {
      this.$router.push({ path: `/group/${this.$route.params.groupId}/remove_member` })
    }
  }
}
</script>

<style scoped lang="scss">
  .no_user{
    font-size: 14px;
    text-align: center;
  }
  .group_name {
    margin-top: 20px;
  }

  .footer_area {
    width: 100%;
    height: 48px;
    padding: 0 8px 8px 8px;
    .btn_quit_group {
      width: 100%;
      height: 40px;
      border-width: 0;
      border-radius: 4px;
      font-size: 15px;
      font-weight: bold;
      color: white;
      background-color:red;
    }
  }


  .default_avatar {
    background-image: url("../assets/avatar.png");
  }
  .bar_btns_right {
    position: absolute;
    top: 0;
    right: 0;
    .btn_add {
      background-image: url("../assets/btn_add.png");
    }
    .btn_remove {
      background-image: url("../assets/btn_del.png");
    }
  }
  .join_area {
    position: relative;
    width: 100%;
    height: 180px;
    padding: 50px 0;
    background-color: #595969;
    .btns {
      position: relative;
      width: 180px;
      height: 80px;
      margin: 0 auto;
      .btn {
        position: absolute;
        width: 60px;
        height: 80px;
        padding-top: 60px;
        font-size: 12px;
        color: white;
        text-align: center;
        background-position: top center;
        background-repeat: no-repeat;
        background-size: contain;
      }
      .qrcode {
        left: 0;
        background-image: url("../assets/btn_qrcode.png");
        cursor: pointer;
      }
      .invite_link {
        right: 0;
        background-image: url("../assets/btn_share.png");
        cursor: pointer;
      }
    }
  }

  .switch_box {
    position: absolute;
    bottom: 0;
    right: 0;
    margin: 12px;
    width: auto;
    height: 32px;
    .text {
      float: right;
      margin: 0 8px;
      height: 32px;
      line-height: 32px;
      font-size: 12px;
      color: white;
    }
    .switch {
      float: right;
      height: 32px;
    }
  }
</style>
